export default "__VITE_ASSET__CR7QVqid__"